import { AppInfoState } from './app-info.interfaces';
import { SocketsConnectionState } from './../../core/shared/base-sockets.interfaces';

export const defaultAppInfoState: AppInfoState = {
    hasFailedToInitReconnection: false,
    isConnectionPopoverShown: false,
    isSoundOn: true,
    socketsConnectionState: SocketsConnectionState.connecting,
};
